import {
  authCallback,
  Footer,
  Imprint,
  imprint,
  infoCenter,
  Login,
  Privacy,
  privacy,
  ServiceCenter,
  TermsOfService,
  termsOfService,
} from '@e2m-customer-portal/core';
import { useSnackbar, useTitle } from '@e2m-customer-portal/hooks';
import { Alert, Snackbar } from '@mui/material';
import { ReactElement } from 'react';
import { Route, Routes } from 'react-router';
import { makeStyles } from 'tss-react/mui-compat';
import { Header, Loading, ScrollToTop } from './ui';

const useStyles = makeStyles()((theme) => ({
  app: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  body: {
    display: 'flex',
    flexGrow: 1,
    marginTop: theme.mixins.toolbar.minHeight,
  },
  content: {
    flexGrow: 1,
    width: '100%',
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
  },
}));

export function AppPublic(): ReactElement {
  const { classes, cx } = useStyles();
  document.title = useTitle().appTitle;
  const { open: snackbarOpen, severity, message, close } = useSnackbar();

  return (
    <div data-testid="loaded" className={cx('App', classes.app)}>
      <ScrollToTop />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={close}
      >
        <Alert severity={severity}>
          <>{message}</>
        </Alert>
      </Snackbar>

      <Header sidebarIsExpanded variant="public" />

      <div className={classes.body}>
        <main className={classes.content}>
          <Routes>
            <Route path={imprint.pattern} element={<Imprint />} />

            <Route path={termsOfService.pattern} element={<TermsOfService />} />

            <Route path={privacy.pattern} element={<Privacy />} />

            <Route path={infoCenter.pattern} element={<ServiceCenter />} />

            <Route
              path={authCallback.pattern}
              element={
                <div className={classes.centered}>
                  <Loading />
                  <Login.RedeemAuthServerCode />
                </div>
              }
            />

            <Route
              path="*"
              element={
                <div className={classes.centered}>
                  <Loading />
                  <Login.RedirectToAuthServer />
                </div>
              }
            />
          </Routes>
          <Footer />
        </main>
      </div>
    </div>
  );
}
